export const INFO_DELETE_RESET = 'INFO_DELETE_RESET';
export const INFO_DELETE_SET_ERROR = 'INFO_DELETE_SET_ERROR';
export const INFO_DELETE_SET_DELETED = 'INFO_DELETE_SET_DELETED';
export const INFO_DELETE_TOGGLE_LOADING = 'INFO_DELETE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/info/delete/mutation_types.js